//import Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux'
//import Components

import { Collapse, Col, Row } from 'reactstrap';
import UpDownTransitionArrow from '../../../../components/UpDownTransitionArrow/UpDownTransitionArrow';
import Article from './Article';
import NewArticle from './NewArticle';

import * as homepageActions from '../actions/homepageActions'
//import Styles
import './ArticleManager.css'


class ArticleManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse : false,

            editingId : -1,
            editing : new Array(props.articles.length).fill(false) 
        }
    }

    toggleEditing = (id) => {
        const currentEditingId = this.state.editingId;
        let newEditingId  = -1;
        let editing = [...this.state.editing];

        const currentIndex = this.props.articles.findIndex((notice) => {
            return notice.id === currentEditingId;
        })
        const newIndex = this.props.articles.findIndex((notice) => {
            return notice.id === id;
        })

        if(this.state.editingId === id) {
            editing[currentIndex] = !editing[currentIndex]
            newEditingId = -1;
        }
        else if(currentEditingId !== id) {
            if(id === null || id === undefined) {
                editing[currentIndex] = !editing[currentIndex];
                newEditingId = -1;
            } else if(currentEditingId  === -1) {
                newEditingId = id;
                editing[newIndex] = !editing[newIndex]
            }
            else {
                editing[currentIndex] = !editing[currentIndex];
                newEditingId = id;
                editing[newIndex] = !editing[newIndex];
            }
        }
        this.setState({
            editing : editing,
            editingId : newEditingId
        })
    }

    askCancleEditing = (func, id) => {
        if(this.state.editingId !== -1) {
            if(this.state.editingId === id) {
                if(func) func();
            }
            else {
                const result = global.confirm('편집중인 공지가 있습니다. 편집을 취소하겠습니까?');
                if (result) {
                    if (func) func();
                }
            }
        }
        else {
            if (func) func(); 
        }
    }


    toggleCollapse = () => {
        this.askCancleEditing(()=>{
            this.toggleEditing();
            this.setState(prevState => ({
                collapse: !prevState.collapse
            }))
        })
    }

    render(){
        const { articles } = this.props;
        const renderArticles = this.props.articles.map((article, index) => {
            if(article.id !== this.props.newArticleId){
                return (
                    <Article
                        askCancleEditing={this.askCancleEditing}
                        toggleEditing={this.toggleEditing}
                        article={article}
                        editing={this.state.editing[index]}
                        index={index + 1}
                        key={index}
                    />
                )
            }
        })

        const renderArticleEmpty = <div className="sub-category no-article">공지가 없습니다</div>

        return (
            <div className="category">
                <div className="main-category" onClick={this.toggleCollapse}>
                    <Row>
                        <Col>
                            <h5>공지관리</h5>
                        </Col>
                        <Col sm={1}>
                            <UpDownTransitionArrow up={this.state.collapse} handleOnClick={this.toggleCollapse} />
                        </Col>
                    </Row>
                </div>
                <Collapse isOpen={this.state.collapse}>
                    <div className="article-container">
                        {
                            articles && 
                            articles.length > 0 ? renderArticles : renderArticleEmpty
                        }
                        <NewArticle 
                            askCancleEditing={this.askCancleEditing}
                            toggleEditing={this.toggleEditing}
                        />
                    </div>
                </Collapse>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        articles : state.admin.homepage.articles,
        newArticleId : state.admin.homepage.newArticleId
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleManager);


// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/ArticleManager/ArticleManager.js